module.exports = __webpack_public_path__ + "img/icon-dexcloud.2bb60828.svg";